/*
 *
 * Author actions
 *
 */

import * as constants from './constants';

export function setPluginTypeList(pluginType, plugins) {
  return {
    type: constants.SET_PLUGIN_TYPE_LIST,
    pluginType,
    plugins,
  };
}

